module.exports = __webpack_public_path__ + "images/jnd30sc.5a6d.png";